import { useEffect, useState } from 'react'

/**
 * Hook to debounce a value
 * @param value - The value to debounce
 * @param delay - The delay in milliseconds (default: 500)
 * @param callBack - Optional callback to be called after debounce
 * @returns The debounced value
 */
export function useDebounce<T>(value: T, delay: number = 500, callBack = () => {}): T {
    const [debouncedValue, setDebouncedValue] = useState<T>(value)

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value)
            callBack()
        }, delay)

        return () => {
            clearTimeout(handler)
        }
    }, [value, delay])

    return debouncedValue
}
